<template>
    <b-tabs pills active-nav-item-class="nav-pill-warning" nav-class="bg-light mx-1 mt-1 p-25 custom-nav">
        <b-tab v-if=hasRole() title="Maaş Bilgileri" lazy active>
            <employee-salary :id="id" v-model="salary" :get-personal="getPersonal" :list="salaries" :garage-salary="businessAgreement.GarageSalaryString"></employee-salary>
        </b-tab>
        <b-tab v-if=hasRole() title="Maaş Bilgileri 2" lazy>
            <employee-maas-bilgileri2 :id="id"/>
        </b-tab>
        <!-- <b-tab title="Sözleşme Bilgileri">
            <employee-agreement-information ref="agreementInformation" :id="id" v-model="businessAgreement" :get-personal="getPersonal"></employee-agreement-information>
        </b-tab> -->
        <b-tab title="Organizasyonel Konum">
            <employee-organizational :id="id" v-on:collar-status-updated="$emit('collar-status-updated', $event)"></employee-organizational>
            <!-- <employee-branch v-model="employeeBranch" :id="id" :get-personal="getPersonal" :can-branch-assignable="canBranchAssignable"></employee-branch> -->
        </b-tab>
        <b-tab v-if="canEntry" title="İşe Giriş" lazy>
            <employee-job-entry v-model="sgkEntryNotice" :get-personal="getPersonal" :id="id" :refresh-notices="refreshNotices" :can-entry="canEntry" :info="info"></employee-job-entry>
        </b-tab>
        <b-tab v-if="canExit" title="İşten Çıkış" lazy>
            <employee-job-exit v-model="sgkExitNotice" :info="info" v-on:exit-done="$emit('exit-done',true)" :can-exit="canExit" :sgk-entry="sgkEntry" :id="id" :get-personal="getPersonal" :is-driver="isDriver"></employee-job-exit>
        </b-tab>
        <b-tab title="İşe Giriş/İşten Çıkış Hareketleri" lazy>
            <employee-job-notices ref="notices" :get-personal="getPersonal" :id="id"></employee-job-notices>
        </b-tab>
        <b-tab title="Sicil Bilgisi" lazy>
            <div class="px-1 pb-1">
                <employee-agreement-information ref="agreementInformation" :id="id" v-model="businessAgreement" :get-personal="getPersonal"></employee-agreement-information>
                <employee-occupation-title :id="id"></employee-occupation-title>
            </div>
        </b-tab>
        <b-tab title="Yemek Kartı Tanımlama" lazy>
            <employee-ticket :id="id"/>
        </b-tab>
        <b-tab title="Destek" lazy>
            <employee-ek-hakedisler v-model="businessAgreement" :id="id" :get-personal="getPersonal"/>
        </b-tab>
        <!-- <b-tab title="BES">
            <employee-bes :business-agreement="businessAgreement"></employee-bes>
        </b-tab> -->
    </b-tabs>
</template>

<script>
import {BTabs,BTab} from 'bootstrap-vue'
import EmployeeSalary from './components/EmployeeSalary.vue'
import EmployeeAgreementInformation from './components/EmployeeAgreementInformation.vue'
import EmployeeBranch from './components/EmployeeBranch.vue'
import EmployeeJobNotices from './components/EmployeeJobNotices.vue'
import EmployeeJobEntry from './components/EmployeeJobEntry.vue'
import EmployeeJobExit from './components/job-exit/EmployeeJobExit.vue'
import EmployeeOccupationTitle from './components/EmployeeOccupationTitle.vue'
import EmployeeBES from './components/EmployeeBES.vue'
import EmployeeOrganizational from './components/EmployeeOrganizational.vue'
import EmployeeTicket from './components/EmployeeTicket.vue'
import EmployeeEkHakedisler from './components/EmployeeEkHakedisler.vue'
import EmployeeMaasBilgileri2 from './components/EmployeeMaasBilgileri2.vue'
import Auth from '@/utilities/auth'
export default {
    components:{
        BTabs,
        BTab,
        EmployeeSalary,
        EmployeeAgreementInformation,
        EmployeeBranch,
        EmployeeJobNotices,
        EmployeeJobEntry,
        EmployeeJobExit,
        EmployeeOccupationTitle,
        'employee-bes':EmployeeBES,
        EmployeeOrganizational,
        EmployeeTicket,
        EmployeeEkHakedisler,
        EmployeeMaasBilgileri2
    },
    props:{
        salary:Object,
        salaries:Object,
        businessAgreement:Object,
        employeeBranch:Object,
        id:[String,Number],
        getPersonal:Function,
        canBranchAssignable:Boolean,
        canExit:Boolean,
        canEntry:Boolean,
        sgkEntryNotice:Object,
        sgkExitNotice:Object,
        sgkEntry:Object,
        isDriver:Boolean,
        info:Object,
    },
    methods:{
        refreshNotices(){
            this.$refs.notices.getNotices()
        },
        hasRole(){
            return Auth.hasRole(['EMPLOYEE_SALARY_OPERATIONS'])
        }
    },
}
</script>

<style>

</style>